import React, { Component } from 'react';

// Define your customized error fallback component
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log("Logging error: ", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI here
      return (
        <div>
          <h1>Đã có lỗi xảy ra.</h1>
          <p>Vui lòng liên hệ Ban quản trị và thử lại sau.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
